import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { AppService } from "../app.service";
import { GlobalsService } from "../globals.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  public constructor(
    private globalsService: GlobalsService,
    private appService: AppService,
    private _router: Router,
  ) {}

  async delay(ms: number) {
    await new Promise<void>((resolve) => setTimeout(() => resolve(), ms)).then(
      () => console.log("fired"),
    );
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const url = state.url.split("?")[0]; // no need to match on query params

    if (this.isInvoicingRoute(url) && this.hasSessionKey(state.url)) {
      this.globalsService.log(
        `auth-guard.service: allowing invoicing route '${url}'`,
      );
      return true;
    }

    if (state.url === "/") {
      this.globalsService.log(`auth-guard.service: '${state.url}'`);
      return true;
    }

    if (this.globalsService.getFeatureSetLoaded()) {
      const featureSet = this.globalsService.getFeatureSet();

      var requiresPassword = featureSet.linkData?.requiresPassword;

      if (
        featureSet?.features.some(
          (m) => m.routerLink && url.startsWith(m.routerLink),
        )
      ) {
        var pwMessage = requiresPassword ? "password protected " : "";
        this.globalsService.log(
          `auth-guard.service: logged in user has ${pwMessage}access to '${url}'`,
        );
        return true;
      } else if (featureSet?.features.length === 0 && url === "/reports-view") {
        // anonymous access to reports view, for CCS Comparison Widget
        this.globalsService.log(
          `auth-guard.service: logged in user has anonymuos access to '${url}'`,
        );
        return true;
      } else {
        this.globalsService.log(
          `auth-guard.service: logged in user does not have access to '${url}'`,
        );
        return false;
      }
    } else {
      return this.globalsService
        .initFeatureSet(state.url)
        .then((featureSet) => {
          this.globalsService.setFeatureSet(featureSet);
          this.globalsService.setFeatureSetLoaded(true);

          var requiresPassword = featureSet.linkData?.requiresPassword;

          if (
            featureSet.features?.some(
              (m) => m.routerLink && url.startsWith(m.routerLink),
            )
          ) {
            var pwMessage = requiresPassword ? "password protected " : "";
            this.globalsService.log(
              `auth-guard.service: logged in user has ${pwMessage}access to '${url}'`,
            );
            return true;
          } else if (
            featureSet.features.length === 0 &&
            url === "/reports-view"
          ) {
            // anonymous access to reports view, for CCS Comparison Widget
            this.globalsService.log(
              `auth-guard.service: logged in user has anonymous access to '${url}'`,
            );
            return true;
          } else {
            this.globalsService.log(
              `auth-guard.service (initFeatures): logged in user does not have access to '${url}'`,
            );
            return false;
          }
        });
    }
  }

  private isInvoicingRoute(url: string): boolean {
    return url === "/invoicing" || url.startsWith("/invoicing/");
  }

  private hasSessionKey(url: string): boolean {
    const queryIndex = url.indexOf("?");

    if (queryIndex < 0) {
      return false;
    }

    const params = new URLSearchParams(url.substring(queryIndex + 1));
    return (params.get("k") ?? "").trim().length > 0;
  }
}
